var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"ct-chart ct-major-twelfth",style:(`min-width: ${_vm.mWidth ?? '1000px'}; `),attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }